import { render, staticRenderFns } from "./navbar-workspaces.vue?vue&type=template&id=0cad0320&scoped=true&"
import script from "./navbar-workspaces.vue?vue&type=script&lang=ts&"
export * from "./navbar-workspaces.vue?vue&type=script&lang=ts&"
import style0 from "./navbar-workspaces.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./navbar-workspaces.vue?vue&type=style&index=1&id=0cad0320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad0320",
  null
  
)

export default component.exports